import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Grid, { Half, Third } from 'grid-styled'
import { findPropertyById } from '../../sources/SearchSource'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import Map from '../../components/Map'
import { Metrics, Fonts, Colors } from '../../Themes'
import { propertyContactRequest } from '../../sources/MailSource'
import { addToFavorites, removeFromFavorites } from '../../sources/UserSource'
import AuthActions from '../../actions/AuthActions'
import ThemeContainer from '../../components/ThemeContainer'
import Key from '../../svg-icons/Key'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import { isUserFavorite, numberWithCommas } from '../../Utils'

import showBackButton from '../../components/showBackButton'

const Container = styled.section`
  text-align: center;
  overflow-y: scroll;
  height: calc(100vh - ${Metrics.components.navbarDefault});
  ${Fonts.style.Text};
  .map {
    display: block;
    width: 100vw;
    height: 700px;
    margin-top: 60px;
    position: relative;
  }
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-bottom: 0;
`

const PropertyNameContainer = styled.div`
  margin: 40px 0;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    margin: ${Metrics.margins.base} 0;
  }
`

const FavoriteIcon = styled(Key)`
  height: 100px;
`

const PropertyTitle = styled(Grid)`
  margin-top: ${Metrics.margins.larger};
  ${Fonts.style.Title};
  color: ${Colors.black};
  span {
    color: ${Colors.primary};
  }
`

const ButtonsContainer = styled(Grid)`
  margin-top: ${Metrics.margins.larger};
`

const CustomRequestButton = styled(Button)`
  ${props => props.left && 'float: left'};
  ${props => props.right && 'float: right'};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    float: none;
    margin-bottom: ${Metrics.margins.small};
  }
`

const DetailsContainer = styled.div`background-color: ${Colors.black};`

const DetailsTitle = styled.div`
  ${Fonts.style.Header};
  margin-bottom: ${Metrics.margins.base};
  color: ${Colors.white};
`

const Details = styled.div`
  width: 500px;
  margin-left: calc((100% - 500px)/2);
  padding: ${Metrics.margins.big} 0;
  color: white;
  text-align: center;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    width: inherit;
    margin-left: 0;
  }
`

const TitleDetail = styled.div`
  ${Fonts.style.Text};
  text-transform: uppercase;
  color: ${Colors.primary};
  margin-top: ${Metrics.margins.larger};
`

const Detail = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.white};
  margin-top: ${Metrics.margins.base};
`

const Description = styled.div`
  color: ${Colors.black};
  border-bottom: ${Metrics.borders.default};
  padding: 40px 0;
  margin-bottom: ${Metrics.margins.base};
`

const LocationsContainer = styled.div`margin: ${Metrics.margins.base} 0;`

const CustomHalf = styled(Half)`
  padding: 0 40px;
  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const LocationsTitle = styled.div`
  ${Fonts.style.Header};
  color: ${Colors.primary};
  margin-bottom: ${Metrics.margins.base};
`

const LocationTitle = styled.div`
  ${Fonts.style.Text};
  text-transform: uppercase;
  margin-top: ${Metrics.margins.base};
`

const Location = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.primary};
  margin-top: ${Metrics.margins.base};
`

const ContactRequest = styled.div`
  margin-top: ${Metrics.margins.larger};

  p {
    margin: ${Metrics.margins.large};
  }

  button {
    margin-top: ${Metrics.margins.large};
    margin-bottom: ${Metrics.margins.larger};
  }
  textarea {
    width: 495px;
    margin-left: calc((1005 - 495px)/2);

    @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
      width: 100%;
      margin-left: 0;
    }
  }
`

const ContactRequestTitle = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.primary};
  margin-bottom: ${Metrics.margins.medium};
`

const Contacts = styled.div`
  border-top: ${Metrics.borders.default};
  padding: ${Metrics.margins.big} 0;
  ${Fonts.style.Input};
  color: ${Colors.black};
`

class PropertyDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      property: null,
      contactForm: '',
      modal: false,
      modalHeader: '',
      modalMessage: '',
      routeId: '',
      favoriteProperty: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.sendEmail = this.sendEmail.bind(this)
    this.addToFavorites = this.addToFavorites.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.removeFromFavorites = this.removeFromFavorites.bind(this)
  }

  componentWillMount () {
    const { user, router } = this.props
    findPropertyById(router.params.id)
      .then(response => {
        this.setState({
          property: response.data,
          favoriteProperty: isUserFavorite(user, response.data),
          routeId: router.params.id
        })
      })
      .catch(console.error)
  }

  componentWillReceiveProps (nextProps) {
    const { user } = this.props
    if (this.state.routeId !== nextProps.router.params.id) {
      findPropertyById(nextProps.router.params.id)
        .then(response => {
          this.setState({
            property: response.data,
            favoriteProperty: isUserFavorite(user, response.data),
            routeId: nextProps.router.params.id
          })
          return
        })
        .catch(console.error)
    }

    if (
      user.preferredProperties.length !==
      nextProps.user.preferredProperties.length
    ) {
      this.setState({
        favoriteProperty: isUserFavorite(nextProps.user, this.state.property)
      })
    }
  }

  handleChange (event) {
    this.setState({ contactForm: event.target.value })
  }

  sendEmail (message) {
    const { t } = this.props
    propertyContactRequest(this.state.property.id, message)
      .then(response => {
        this.setState({
          modal: 'success',
          modalHeader: t('Mail Sent'),
          modalMessage: t('Your contact request was successfully sent')
        })
      })
      .catch(error => {
        console.log(error)
        this.setState({
          modal: 'error',
          modalHeader: t('Error'),
          modalMessage: t('There was a prolem when sending the email')
        })
      })
  }

  addToFavorites () {
    const { t } = this.props
    addToFavorites(this.props.user.id, this.state.property.id, 'property')
      .then(response => {
        this.setState({
          favoriteProperty: true,
          modal: 'success',
          modalHeader: t('Property Added'),
          modalMessage: t(
            'The property was successfully added to your favourites'
          )
        })
        AuthActions.updateToken(response.data.authToken)
      })
      .catch(error => {
        console.log(error)
        this.setState({
          modal: 'error',
          modalHeader: t('Error'),
          modalMessage: t(
            'There was an error when adding the property to your favourites'
          )
        })
      })
  }

  removeFromFavorites () {
    const { t } = this.props
    removeFromFavorites(this.props.user.id, this.state.property.id, 'property')
      .then(response => {
        this.setState({
          favoriteProperty: false,
          modal: 'success',
          modalHeader: t('Property Removed'),
          modalMessage: t(
            'The property was successfully removed from your favourites'
          )
        })
        AuthActions.updateToken(response.data.authToken)
      })
      .catch(error => {
        console.log(error)
        this.setState({
          modal: 'error',
          modalHeader: t('Error'),
          modalMessage: t(
            'There was an error when removing the property from favorites'
          )
        })
      })
  }

  closeModal () {
    this.setState({
      modal: false
    })
  }

  render () {
    const {
      property,
      favoriteProperty,
      modal,
      modalHeader,
      modalMessage
    } = this.state
    const { t } = this.props
    return (
      <Container>
        <ErrorModal
          visible={modal === 'error'}
          message={modalMessage}
          closeAction={this.closeModal}
          header={modalHeader}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={modalMessage}
          closeAction={this.closeModal}
          header={modalHeader}
        />
        {property ? (
          <div>
            <CustomThemeContainer>
              <PropertyNameContainer>
                <FavoriteIcon
                  className={`${!this.state.favoriteProperty && 'notFavorite'}`}
                />
                <PropertyTitle>
                  <span>{property.title}, </span>
                  {property.city.city}
                </PropertyTitle>
                <ButtonsContainer>
                  <Half>
                    <CustomRequestButton
                      right
                      label={t('Request for more information')}
                      onClick={() => {
                        window.location.href = '#property-contact'
                      }}
                    />
                  </Half>
                  <Half>
                    <CustomRequestButton
                      left
                      label={
                        favoriteProperty ? t('Favorite') : t('Add to Favorites')
                      }
                      onClick={() => {
                        favoriteProperty
                          ? this.removeFromFavorites()
                          : this.addToFavorites()
                      }}
                      grey={favoriteProperty}
                    />
                  </Half>
                </ButtonsContainer>
              </PropertyNameContainer>
            </CustomThemeContainer>
            <DetailsContainer>
              <CustomThemeContainer>
                <Details>
                  <DetailsTitle>{t('Property Details')}</DetailsTitle>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Property Type')}</TitleDetail>
                    <Detail>{property.category.name}</Detail>
                  </CustomHalf>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Property Area')}</TitleDetail>
                    <Detail>{property.area}</Detail>
                  </CustomHalf>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Number of Keys')}</TitleDetail>
                    <Detail>{property.noRooms}</Detail>
                  </CustomHalf>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Portfolio')}</TitleDetail>
                    <Detail>{property.portfolio ? 'Yes' : 'No'}</Detail>
                  </CustomHalf>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Estimated Yield')}</TitleDetail>
                    <Detail>{property.yield}%</Detail>
                  </CustomHalf>
                  <CustomHalf xs={1 / 2}>
                    <TitleDetail>{t('Price')}</TitleDetail>
                    <Detail>{numberWithCommas(property.price)}€</Detail>
                  </CustomHalf>
                </Details>
              </CustomThemeContainer>
            </DetailsContainer>
            <CustomThemeContainer>
              <Description>{property.description}</Description>
              <LocationsContainer>
                <LocationsTitle>{t('Property Location')}</LocationsTitle>
                <Grid>
                  <Third className='location-container'>
                    <LocationTitle>{t('Continent')}</LocationTitle>
                    <Location>{property.continent.name}</Location>
                  </Third>
                  <Third className='location-container'>
                    <LocationTitle>{t('Country')}</LocationTitle>
                    <Location>{property.country.name}</Location>
                  </Third>
                  <Third className='location-container'>
                    <LocationTitle>{t('Metropolitan Area')}</LocationTitle>
                    <Location>{property.city.city}</Location>
                  </Third>
                </Grid>
              </LocationsContainer>
            </CustomThemeContainer>
            <div>
              <div className='map'>
                {property && (
                  <Map
                    initialCenter={{
                      lat: parseFloat(property.latlng.latitude),
                      lng: parseFloat(property.latlng.longitude)
                    }}
                    places={[ property ]}
                    zoom={12}
                    scrollable={false}
                    draggable={false}
                    disableUI
                  />
                )}
              </div>
            </div>
            <CustomThemeContainer>
              <ContactRequest id='property-contact'>
                <ContactRequestTitle>
                  {t('Request for more information')}
                </ContactRequestTitle>
                <p>{t('Interested in this house? Please contact us')}</p>
                <Textarea
                  handleChange={this.handleChange}
                  placeholder={t('Drop us a line')}
                  value={this.state.contactForm}
                />
                <Button
                  onClick={() => this.sendEmail(this.state.contactForm)}
                  label='Send'
                />
              </ContactRequest>
            </CustomThemeContainer>
          </div>
        ) : (
          t('Not Found')
        )}
        <Contacts>
          <Half>invest@hvb-investments.com</Half>
          <Half>Münsterhof 6, 8001 Zürich</Half>
        </Contacts>
      </Container>
    )
  }
}

PropertyDetails.propTypes = {
  router: PropTypes.object,
  user: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'search', 'forms' ], { wait: true })(
  showBackButton(PropertyDetails)
)



// WEBPACK FOOTER //
// ./src/pages/Search/PropertyDetails.js